import {
	ADD_TYPING_INDICATOR,
	REMOVE_TYPING_INDICATOR,
} from '../actions/types.js';

const INITIAL_STATE = []; // fill with typingIndicators = {_customerConversation | _teamConversation: ID, whoIsTyping: String}

// A conversation can have several people typing at once (e.g. two teammates in
// the same inbox thread), so each typer is tracked independently by the
// conversation it belongs to AND who is typing. Keying only on the conversation
// would drop every typer after the first and leave the wrong name on screen.
// Events relayed between realtime servers arrive with unset ids as null rather
// than missing, so null and missing must match or one copy never clears.
const isSameId = (a, b) => (a ?? '') === (b ?? '');

const isSameTyper = (a, b) =>
	a.whoIsTyping === b.whoIsTyping &&
	isSameId(a._customerConversation, b._customerConversation) &&
	isSameId(a._teamConversation, b._teamConversation);

export default function typingIndicatorReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case ADD_TYPING_INDICATOR:
			// avoid duplicating the same person in the same conversation
			if (state.some((t) => isSameTyper(t, action.payload))) {
				return state;
			}

			return [...state, action.payload];

		case REMOVE_TYPING_INDICATOR:
			return state.filter((t) => !isSameTyper(t, action.payload));

		default:
			return state;
	}
}
